// Example: About.js
import React from 'react';

const About = () => (
  <div className="min-h-screen flex items-center justify-center bg-background text-text">
    <h1 className="text-3xl font-bold">About BetterTurns</h1>
  </div>
);

export default About;
